export default "__VITE_ASSET__Q08zv17O__"